// import required libraries
import $ from "jquery";

// import components that run on every page
import Header from "./components/Header";

// Import Pages
import PageContact from "./pages/PageContact";
import accessibility from "./actions/accessibility";
import PageFrontPage from "./pages/PageFrontPage";
import PageNews from "./pages/PageNews";
import Page404 from "./pages/Page404";
import renderFeaturedSlider from "./actions/renderFeaturedSlider";

// call functions
accessibility();
PageContact($);
PageFrontPage($);
PageNews($);
Header($);
Page404($);
renderFeaturedSlider($)
